module.exports = __webpack_public_path__ + "img/2.bfac07f1.png";